<template>
    <div>
        <div v-for="(file, index) of files" :key="index" class="upload-summary__files">
            <div :class="fileDataClass(file)">
                <div :class="fileNameClass(file)">
                    {{ fileName(file) }}
                    <b v-if="file.errorMessage && !isUploading">- {{ file.errorMessage }}</b>
                </div>
                <common-icon
                    class="upload-summary__close-ico"
                    name="close"
                    size="tiny"
                    @click="emitEvent({ name: 'remove-file', payload: file })"
                ></common-icon>
            </div>

            <common-progress
                v-show="showProgress(file)"
                class="upload-summary__progress"
                height="small"
                color="secondary"
                :percentage="file.progress"
                :showSuccessIcon="false"
            ></common-progress>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            files: { type: Array, required: true },
            isUploading: { type: Boolean, default: false },
            isCenter: { type: Boolean, default: false },
        },

        methods: {
            showProgress(file) {
                return this.isUploading && !file.isUploaded
            },

            fileDataClass(file) {
                return {
                    'upload-summary__file': true,
                    'upload-summary__file--center': this.isCenter,
                    'upload-summary__file--error': !!file.errorMessage && !this.isUploading,
                    'upload-summary__file--uploaded': file.isUploaded,
                }
            },

            fileNameClass(file) {
                return {
                    'upload-summary__file--name': true,
                    'upload-summary__file--name-error': !!file.errorMessage && !this.isUploading,
                }
            },

            fileName(file) {
                if ((this.isUploading && !file.isUploaded) || file.errorMessage) {
                    return `${file.file.name} (${(file.file.size / 1000).toFixed(2)} kb)`
                }
                return file.file.name
            },
        },
    }
</script>
